<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'LayoutController',
  computed: {
    isLoadingData() {
      return this.$store.getters['app/is_loading']
    },
  },
  watch: {
    isLoadingData(val) {
      if (!val) {
        setTimeout(() => {
          this.updateLayout()
        })
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateLayout()
    })
    window.addEventListener('resize', this.updateLayout)
    this.$router.afterEach(() => {
      this.updateLayout()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateLayout)
  },

  methods: {
    updateLayout() {
      this.$nextTick(() => {
        const elements = document.querySelectorAll('.dynamic-height')
        let totalHeight = 0

        elements.forEach((el) => {
          totalHeight += this.getTotalHeight(el)
        })

        document.documentElement.style.setProperty('--dynamic-total-height', `${totalHeight}px`)
        this.adjustCenterDivPosition()
      })
    },
    getTotalHeight(el) {
      const style = window.getComputedStyle(el)
      const margins = parseInt(style.marginTop) + parseInt(style.marginBottom)
      return el.offsetHeight + margins
    },

    adjustCenterDivPosition() {
      const mainWrapper = document.querySelector('.dynamic-width-main')
      const leftDiv = document.querySelector('.dynamic-width-left')
      const rightDiv = document.querySelector('.dynamic-width-right')
      const centerDiv = document.querySelector('.dynamic-width-center')

      if (!mainWrapper || !leftDiv || !centerDiv) {
        return
      }

      const mainWidth = mainWrapper.offsetWidth
      const leftWidth = leftDiv.offsetWidth + this.getTotalMarginPadding(leftDiv)
      const rightWidth = rightDiv ? rightDiv.offsetWidth + this.getTotalMarginPadding(rightDiv) : 0
      const centerWidth = centerDiv.offsetWidth
      const availableSpace = mainWidth - leftWidth - rightWidth

      if (availableSpace <= centerWidth) {
        centerDiv.style.position = 'static'
        centerDiv.style.left = '0'
        centerDiv.style.transform = 'translateX(0)'
      } else {
        centerDiv.style.position = 'absolute'
        centerDiv.style.left = '50%'
        centerDiv.style.transform = 'translateX(-50%)'
      }

      if (availableSpace < centerWidth || this.isOverlapping(centerDiv, leftDiv) || (rightDiv && this.isOverlapping(centerDiv, rightDiv))) {
        centerDiv.style.removeProperty('position')
        centerDiv.style.removeProperty('left')
        centerDiv.style.removeProperty('transform')
      } else {
        centerDiv.style.position = 'absolute'
        centerDiv.style.left = '50%'
        centerDiv.style.transform = 'translateX(-50%)'
      }
    },
    getTotalMarginPadding(element) {
      const styles = window.getComputedStyle(element)
      const totalHorizontal =
        parseInt(styles.marginLeft) + parseInt(styles.marginRight) + parseInt(styles.paddingLeft) + parseInt(styles.paddingRight)
      return totalHorizontal
    },
    isOverlapping(el1, el2) {
      if (!el2) return false
      const rect1 = el1.getBoundingClientRect()
      const rect2 = el2.getBoundingClientRect()

      return !(rect1.top > rect2.bottom || rect1.right < rect2.left || rect1.bottom < rect2.top || rect1.left > rect2.right)
    },
  },
}
</script>

<style>
:root {
  --dynamic-total-height: 0px;
}
.dynamic-width-main {
  position: relative;
}
</style>
